<template>
  <div style="width: 100%; text-align: center">
    <span
      :class="readonly ? 'ro' : ''"
      style="padding-right: 12px"
      v-lego-tooltip="t('button.MAIL')"
    >
      <lego-icon
        @click="onClick('MAIL')"
        iconType="df"
        icon="noti_mail"
        :size="20"
        :class="email ? 'alert-available' : 'alert-unavailable'"
      />
      <!-- <lego-tooltip bottom mouseOver>{{t('button.MAIL')}}</lego-tooltip> -->
    </span>
    <span
      :class="readonly ? 'ro' : ''"
      style="padding-right: 12px"
      v-lego-tooltip="t('button.SMS')"
    >
      <lego-icon
        @click="onClick('SMS')"
        iconType="df"
        icon="noti_sms"
        :size="20"
        :class="sms ? 'alert-available' : 'alert-unavailable'"
      />
      <!-- <lego-tooltip bottom mouseOver>{{ t('button.SMS') }}</lego-tooltip> -->
    </span>

    <span :class="readonly ? 'ro' : ''" v-lego-tooltip="t('button.MESSENGER')">
      <lego-icon
        @click="onClick('MESSENGER')"
        iconType="df"
        icon="noti_messenger"
        :size="20"
        :class="messenger ? 'alert-available' : 'alert-unavailable'"
      />
      <!-- <lego-tooltip bottom mouseOver>{{ t('button.MESSENGER') }}</lego-tooltip> -->
    </span>
  </div>
</template>
<script>
import i18nMixin from '@/mixins/i18n.mixin.js';
export default {
  mixins: [i18nMixin],
  props: ['index', 'eventLevel', 'sendMethod', 'readonly'],
  name: 'ScpmMethodSelect',
  inject: ['clickAction'],
  computed: {
    email() {
      return this.sendMethod.includes('MAIL');
    },
    sms() {
      return this.sendMethod.includes('SMS');
    },
    messenger() {
      return this.sendMethod.includes('MESSENGER');
    }
  },

  data() {
    return {};
  },
  methods: {
    onClick(type) {
      if (this.readonly) return;
      this.clickAction(this.index, this.eventLevel, type);
    }
  }
};
</script>
<style>
.ro .alert-available {
  cursor: default !important;
}
.ro .alert-unavailable {
  cursor: default !important;
}
.alert-available svg path {
  fill: #2c59d9 !important;
}
</style>
